export function removeProperties(obj, props) {
    const newObj = { ...obj };
    props.forEach(prop => delete newObj[prop]);
    return newObj;
}